var _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_2560_5589)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2866 0H0V21.939H17.7706V5.48404L12.2866 0Z",
    fill: "#FA4E4E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4485 14.7752C11.7082 14.7202 10.9955 14.4453 10.4197 13.9504C9.29562 14.1978 8.22623 14.5551 7.15698 14.9951C6.30712 16.5071 5.51196 17.2769 4.82651 17.2769C4.68939 17.2769 4.52498 17.2495 4.41529 17.1669C4.11362 17.0296 3.94922 16.7271 3.94922 16.4247C3.94922 16.1772 4.00407 15.49 6.60864 14.3627C7.21196 13.263 7.67789 12.1359 8.06183 10.9538C7.73274 10.294 7.02 8.67188 7.51335 7.84725C7.67789 7.54476 8.00698 7.37981 8.36349 7.40737C8.63759 7.40737 8.91169 7.54476 9.07623 7.7647C9.43274 8.25956 9.40532 9.30427 8.93911 10.8438C9.3779 11.6674 9.9526 12.411 10.639 13.0432C11.2149 12.9331 11.7905 12.8507 12.3663 12.8507C13.6549 12.8781 13.8469 13.483 13.8195 13.8404C13.8195 14.7752 12.9146 14.7752 12.4485 14.7752V14.7752ZM4.77179 16.4796L4.85407 16.4521C5.23786 16.3148 5.53939 16.0398 5.75878 15.6824C5.34742 15.8473 5.01847 16.1222 4.77179 16.4797V16.4796ZM8.4182 8.23214H8.33593C8.3085 8.23214 8.25366 8.23214 8.22623 8.25956C8.11654 8.72686 8.19881 9.22173 8.39078 9.6616C8.55532 9.1943 8.55532 8.69944 8.4182 8.23214V8.23214ZM8.61017 12.2185L8.58274 12.2733L8.55532 12.2459C8.3085 12.8783 8.03427 13.5105 7.73274 14.1154L7.78759 14.0879V14.1428C8.39729 13.9217 9.01992 13.7381 9.652 13.5929L9.62457 13.5655H9.70684C9.29549 13.1531 8.91169 12.6858 8.61017 12.2185V12.2185ZM12.3388 13.6755C12.092 13.6755 11.8728 13.6755 11.626 13.7303C11.9002 13.8679 12.1744 13.9228 12.4485 13.9504C12.6405 13.9778 12.8325 13.9504 12.9969 13.8954C12.9969 13.8129 12.8872 13.6755 12.3388 13.6755Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7715 5.48477L12.2867 1.33488e-05C12.2867 3.02916 14.7423 5.48477 17.7715 5.48477Z",
    fill: "#FDB8B8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_2560_5589",
    x: 0,
    y: -1,
    width: 17.7715,
    height: 23.939,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2560_5589"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2560_5589",
    result: "effect2_innerShadow_2560_5589"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.f6948800eba8807ff10cd701835ab847.svg";
export { ForwardRef as ReactComponent };